import { render, staticRenderFns } from "./StaffManagement.vue?vue&type=template&id=e2e8a642&scoped=true"
import script from "./StaffManagement.vue?vue&type=script&lang=js"
export * from "./StaffManagement.vue?vue&type=script&lang=js"
import style0 from "./StaffManagement.vue?vue&type=style&index=0&id=e2e8a642&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2e8a642",
  null
  
)

export default component.exports